<span class="chip__content">
  <ng-content></ng-content>
</span>
<button
  *ngIf="removable"
  type="button"
  class="chip__remove"
  (click)="handleRemove($event)"
  [disabled]="disabled"
>
  <ng-content select="[remove-icon]"></ng-content>
</button>
